import React from "react";
import { Phone, MapPin, Clock, Instagram } from "lucide-react";

export const Footer = () => (
    <footer className="border-t border-white/10 mt-24 bg-[#0c0c0e]" data-testid="footer">
        <div className="mx-auto max-w-7xl px-4 sm:px-8 py-12 grid md:grid-cols-4 gap-10">
            <div>
                <div className="flex items-center gap-2 mb-4">
                    <img
                        src="https://customer-assets.emergentagent.com/job_burger-box/artifacts/95o5mfjp_image.png"
                        alt="Grill Bros"
                        className="h-10 w-10 object-contain"
                    />
                    <span className="headline text-xl">GRILL BROS</span>
                </div>
                <p className="text-xs uppercase tracking-[0.3em] text-brand-yellow mb-3">Est. 2013</p>
                <p className="text-sm text-white/60 leading-relaxed">
                    Χειροποίητα μπιφτέκια, φρέσκα υλικά κάθε μέρα. 100% αγνό μοσχάρι, ψωμιά brioche, sauces από τη μάνα μας.
                </p>
            </div>
            <div>
                <h4 className="font-heading uppercase text-sm tracking-wider text-brand-red mb-3">Επικοινωνία</h4>
                <ul className="space-y-2 text-sm text-white/70">
                    <li className="flex items-center gap-2"><Phone size={14} /> 231 022 5855</li>
                    <li className="flex items-start gap-2"><MapPin size={14} className="mt-1 shrink-0" /> Ελ. Βενιζέλου 72, Θεσσαλονίκη 546 31</li>
                </ul>
            </div>
            <div>
                <h4 className="font-heading uppercase text-sm tracking-wider text-brand-red mb-3">Ώρες</h4>
                <ul className="space-y-2 text-sm text-white/70">
                    <li className="flex items-center gap-2"><Clock size={14} /> Δευτ–Πέμ: 12:00 – 23:30</li>
                    <li className="flex items-center gap-2"><Clock size={14} /> Παρ–Κυρ: 12:00 – 01:00</li>
                </ul>
            </div>
            <div>
                <h4 className="font-heading uppercase text-sm tracking-wider text-brand-red mb-3">Social</h4>
                <a href="#" className="flex items-center gap-2 text-sm text-white/70 hover:text-white">
                    <Instagram size={14} /> @smashhouse.gr
                </a>
            </div>
        </div>
        <div className="border-t border-white/10 py-4 text-center text-xs text-white/40">
            © {new Date().getFullYear()} Grill Bros — Est. 2013. All rights reserved.
        </div>
    </footer>
);
